<template>
  <Page>
    <section class="applogs-container">
      <Announce style="margin-top: 8px;" />
      <Breadcrumb title="定制化日志" />
      <ListFilter :formList="filterFormList" @search="searchHandle" />
      <div class="logs-list">
        <el-table v-sticky="{ top: 140, parent: '.applogs-container', zIndex: 996 }" :data="list" style="width: 100%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
          <template #empty><Empty style="margin-top: 56px;" /></template>
          <el-table-column fixed prop="traceId" label="任务ID" width="208" />
          <el-table-column prop="username" label="用户名称" width="156" show-overflow-tooltip />
          <el-table-column prop="appName" label="应用名称" width="208" show-overflow-tooltip />
          <el-table-column prop="accountUseCountInfos" label="账号（消耗次数）" width="228">
            <template #default="scope">
              <div style="display: flex; flex-direction: column; gap: 6px;" v-if="scope.row.accountUseCountInfos?.length > 0">
                <template v-for="(item, index) in scope.row.accountUseCountInfos">
                  <span v-if="item?.account">{{ item?.account }}（{{ item?.totalUseCount || '-' }}）</span>
                  <span v-else>-</span>
                </template>
              </div>
              <div v-else>-</div>
            </template>
          </el-table-column>
          <el-table-column prop="displayName" label="参数模版" width="208" />
          <el-table-column prop="reqFileName" label="初始上传文件" width="180" show-overflow-tooltip />
          <el-table-column prop="rt" label="用时（秒）" width="108"></el-table-column>
          <el-table-column prop="progress" label="进度" />
          <el-table-column prop="status" label="状态" width="120">
            <template #default="scope">
              <span class="statusitem"><em :style="{ backgroundColor: CONST.LOGS_STATUS_COLOR[scope.row.statusCode] }" />{{ CONST.LOGS_STATUS_LABEL[scope.row.statusCode] }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="createdTime" label="创建时间" width="150">
            <template #default="scope">
              <span>{{ scope.row.createdTime && momemt(scope.row.createdTime).format('YYYY MM.DD HH:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="executedTime" label="执行时间" width="150">
            <template #default="scope">
              <span>{{ scope.row.executedTime && momemt(scope.row.executedTime).format('YYYY MM.DD HH:mm') }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updatedTime" label="更新时间" width="150">
            <template #default="scope">
              <span>{{ scope.row.updatedTime && momemt(scope.row.updatedTime).format('YYYY MM.DD HH:mm') }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="edit" label="操作" fixed="right" width="208" align="right">
            <template #default="scope">
              <el-popconfirm title="你确定要暂停任务吗?" width="208px" v-if="[CONST.LOGS_STATUS_PENDING, CONST.LOGS_STATUS_RUNNING].includes(scope.row.statusCode)">
                <template #reference>
                  <el-button link type="warning">暂停</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="pauseHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>
              <el-button link type="primary" @click="resumeHandle(scope.row)" v-if="[CONST.LOGS_STATUS_PAUSED].includes(scope.row.statusCode)">继续</el-button>


              <el-popconfirm title="你确定要停止任务吗?" width="208px" v-if="[CONST.LOGS_STATUS_PENDING, CONST.LOGS_STATUS_RUNNING].includes(scope.row.statusCode)">
                <template #reference>
                  <el-button link type="danger">停止</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="stopHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>

              <el-button link type="primary" @click="updateHandle(scope.row)" v-if="[CONST.LOGS_STATUS_PENDING, CONST.LOGS_STATUS_RUNNING, CONST.LOGS_STATUS_STOPPING].includes(scope.row.statusCode)">更新</el-button>

              <el-popconfirm title="确认后，任务结果将自动下载至电脑。" width="208px" v-if="[CONST.LOGS_STATUS_FINISH, CONST.LOGS_STATUS_ERROR, CONST.LOGS_STATUS_STOP].includes(scope.row.statusCode) && scope.row?.resultFileUrl">
                <template #reference>
                  <el-button link type="primary">结果</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="resultHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>

              <el-popconfirm title="确认后，初始上传文件将自动下载至电脑。" width="208px">
                <template #reference>
                  <el-button link type="primary">文件</el-button>
                </template>
                <template #actions="{ confirm, cancel }">
                  <el-button @click="cancel" size="small">取消</el-button>
                  <el-button type="primary" size="small" @click="fileDownloadHandle(scope.row, confirm)">确定</el-button>
                </template>
              </el-popconfirm>

              <el-button link type="primary" @click="detailHandle(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Spagination
          wstyle="margin-top: 24px"
          :page="page"
          :size="size"
          :total="total"
          @current-change="val => page = val"
        />
      </div>
    </section>
  </Page>

  <el-dialog v-model="detailFlag" title="详情" width="83%">
    <el-table :data="detailList" style="width: 100%; height: 80%; color: #232326;" :header-cell-style="{ fontWeight: 500, color: '#232326', backgroundColor: '#F8F9FA' }">
      <template #empty><Empty style="margin-top: 56px;" /></template>
      <el-table-column prop="traceId" label="子任务ID" width="200" />
      <el-table-column prop="paramsCore" label="核心参数" />
      <el-table-column prop="accountUseCountInfos" label="账号（消耗次数）" width="156px">
        <template #default="scope">
          <span v-if="scope.row?.account" style="white-space: wrap; word-wrap: break-word;">{{ scope.row?.account }}（{{ scope.row?.useCount || '-' }}）</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="resultCore" label="核心结果" />
      <el-table-column prop="status" label="状态" width="128px">
        <template #default="scope">
          <span class="statusitem"><em :style="{ backgroundColor: CONST.SUB_LOGS_STATUS_COLOR[scope.row.status] }" />{{ CONST.SUB_LOGS_STATUS_LABEL[scope.row.status] }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="rt" label="用时（秒）"></el-table-column>
      <el-table-column prop="machineName" label="执行机器"></el-table-column>
      <el-table-column prop="createdTime" label="开始时间">
        <template #default="scope">
          <span>{{ scope.row.createdTime && momemt(scope.row.createdTime).format('YYYY MM.DD HH:mm') }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="updatedTime" label="结束时间">
        <template #default="scope">
          <span>{{ scope.row.updatedTime && momemt(scope.row.updatedTime).format('YYYY MM.DD HH:mm') }}</span>
        </template>
      </el-table-column>
    </el-table>
    <Spagination
      :page="detailPage"
      :size="detailSize"
      :total="detailTotal"
      @current-change="val => detailPage = val"
    />
  </el-dialog>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import momemt from 'moment'

  import * as Request from '@/assets/request';
  import * as CONST from '@/assets/const';
  import * as Utils from '@/assets/utils';

  import Announce from '@/components/announce';
  import Empty from '@/components/empty';
  import Page from '@/components/page';
  import Breadcrumb from '@/components/breadcrumb';
  import ListFilter from '@/components/listFilter';
  import Spagination from '@/components/spagination';
  import { ElMessage } from 'element-plus';

  /**
   * 筛选
   */
  const filterFormList = ref([])
  const getAccountOptions = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/carrier/account/searchList',
      data: {
        page: 1,
        size: 50
      }
    });
    if(result?.code != 200) return;
    const list = result.data.content || []
    const accountOptions = list.map(i =>
      i.accounts.map(account => {
        account.carrierCode = i.carrierCode;
        return account;
      })
    )
    .flat()
    .filter(i => i.deleteStatus === 1)
    .map(i => ({ value: i.id, label: `${i.account}(${i.carrierCode})` }))
    filterFormList.value.forEach(item => {
      if (item.field == 'accountIdList') {
        item.options = accountOptions
      }
    })
  }
  const filterFormListInit = async () => {
    const traceId = Utils.getSearchByKey('traceId');
    const timerTaskId = Utils.getSearchByKey('timerTaskId');
    filterFormList.value = [
      {
        type: 'input', field: 'traceId',
        label: '任务ID', placeholder: '请输入',
        value: traceId || undefined
      },
      {
        type: 'input', field: 'timerTaskId',
        label: '计划ID', placeholder: '请输入',
        value: timerTaskId || undefined
      },
      {
        type: 'userselect', field: 'userId',
        label: '用户名', placeholder: '请选择',
        options: []
      },
      {
        type: 'select', field: 'appIds', multiple: true, collapseTags: true,
        label: '应用名', placeholder: '请选择',
        options: []
      },
      {
        type: 'select', field: 'statusCode',
        label: '状态', placeholder: '请选择',
        options: Object.keys(CONST.LOGS_STATUS_LABEL).map(value => ({ value: Number(value), label: CONST.LOGS_STATUS_LABEL[value] }))
      },
      {
        type: 'datetimerange', field: 'updatedDateRange', valueFormat: 'x',
        label: '更新时间', placeholder: '请选择',
      },
      {
        type: 'datetimerange', field: 'createdDateRange', valueFormat: 'x',
        label: '创建时间', placeholder: '请选择',
      },
      {
        type: 'select', field: 'accountIdList', multiple: true,
        label: '账号', placeholder: '请选择', collapseTags: true,
        options: []
      },
    ];

    if(timerTaskId) {
      listQuery.value = {
        ...listQuery.value,
        timerTaskId
      }
    }
    if(traceId) {
      listQuery.value = {
        ...listQuery.value,
        traceId
      }
    }
  }
  onMounted(() => {
    filterFormListInit();
    getAccountOptions(),
    getSpecificAppIds().then(() => {
      getAllApp(),
      getList()
    })
  })

  // 获取特殊需要过滤的appId
  let specificAppIds = []
  const getSpecificAppIds = () => Request.post({
    url: '/22001/facade/dispatch/getSpecificAppIds'
  }).then(res => {
    if(res?.code != 200) return;
    specificAppIds = res.data
  })

  // 获取所有app
  const getAllApp = async () => {
    const result = await Request.post({
      url: '/22001/facade/commons/params/template/getAllApp'
    });
    if(result?.code != 200) return;

    let _options = [];
    if(result?.data?.length > 0) {
      result.data.map(item => {
        if(item.apps?.length > 0) {
          item.apps.map(_item => {
            _options.push({ value: _item?.id, label: _item?.name })
          })
        }
      })
    }
    filterFormList.value.map(item => {
      if(item?.field == 'appIds') {
        item.options = _options.filter(item => specificAppIds.includes(item.value))
      }
      return item;
    })
  }

  /**
   * 列表
   */
  const list = ref([])
  const listQuery = ref({})
  const total = ref(0)
  const size = ref(50)
  const page = ref(1)
  const getList = async () => {
    const params = {
      ...listQuery.value,
      page: page.value,
      size: size.value,
    }
    if (!params.appIds || params.appIds.length === 0) {
      params.appIds = specificAppIds
    }
    const result = await Request.post({
      url: '/22001/facade/user/log/searchList',
      data: params,
    });
    if(result?.code != 200) return;

    list.value = result.data.content;
    total.value = result.data.total;
  }
  watch(() => [ listQuery.value, page.value ], () => {
    getList();
  }, { deep: true })

  // 搜索
  const searchHandle = data => {
    listQuery.value = {...data};
    page.value = 1;
  }

  /**
   * 操作
   */
  // 停止
  const stopHandle = async (item) => {
    const result = await Request.post({
      url: '/22001/facade/user/log/stop',
      data: item?.id
    });
    if(result?.code != 200) return;
    ElMessage.success('停止成功');
    getList()
  }

  // 暂停
  const pauseHandle = async (item) => {
    const result = await Request.post({
      url: '/22001/facade/user/log/pause',
      data: item?.id
    });
    if(result?.code != 200) return;
    ElMessage.success('操作成功');
    getList()
  }
  // 继续
  const resumeHandle = async (item) => {
    const result = await Request.post({
      url: '/22001/facade/user/log/resume',
      data: item?.id
    });
    if(result?.code != 200) return;
    ElMessage.success('操作成功');
    getList()
  }

  // 更新
  const updateHandle = async (item) => {
    const result = await Request.post({
      url: '/22001/facade/user/log/getUpdate',
      data: item?.id
    });
    if(result?.code != 200) return;
    ElMessage.success('更新成功');
    getList()
  }

  // 文件
  const fileDownloadHandle = (item) => {
    window.open(item?.reqFileUrl);
    ElMessage.success('下载成功');
  }

  // 详情
  const detailFlag = ref(false);
  const detailObj = ref(null);
  const detailHandle = async (item) => {
    detailObj.value = item;
    detailFlag.value = true;
  }
  const detailList = ref([])
  const detailListQuery = ref({})
  const detailTotal = ref(0)
  const detailSize = ref(50)
  const detailPage = ref(1)
  const detailListHandle = async () => {
    const result = await Request.post({
      url: '/22001/facade/user/log/detail',
      data: {
        ...detailListQuery.value,
        id: detailObj.value?.id,
        page: detailPage.value,
        size: detailSize.value
      }
    });
    if(result?.code != 200) return;

    detailList.value = result.data.content;
    detailTotal.value = result.data.total;
  }
  watch(() => [ detailObj.value, detailPage.value ], () => {
    detailListHandle();
  }, { deep: true })

  // 结果
  const resultHandle = (item) => {
    window.open(item?.resultFileUrl);
    ElMessage.success('下载成功');
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
